import varAxios from "../../Comman/axios";
import { saveOrganizationUrl } from "../../Comman/apiEndPoints"

export const FETCH_ORGANIZATION_REQUEST = "(organization) FETCH ORGANIZATION REQUEST";
export const FETCH_ORGANIZATION_SUCCESS = "(organization) FETCH ORGANIZATION SUCCESS";
export const FETCH_ORGANIZATION_ERROR = "(organization) FETCH ORGANIZATION ERROR";


export function fetchOrganizationRequest({ organizationName, organizationNumber, organizationPhoneNumber, organizationAddress, pinCode, city, state, country, isLoading }) {
    return {
        type: FETCH_ORGANIZATION_REQUEST,
        organizationName,
        organizationNumber,
        organizationPhoneNumber,
        organizationAddress,
        pinCode,
        city,
        state,
        country,
        isLoading
    }
}

export function fetchOrganizationSuccess({ organizationName, organizationNumber, organizationPhoneNumber, organizationAddress, pinCode, city, state, country, isLoading, Message }) {
    ;
    return {
        type: FETCH_ORGANIZATION_SUCCESS,
        organizationName,
        organizationNumber,
        organizationPhoneNumber,
        organizationAddress,
        pinCode,
        city,
        state,
        country,
        isLoading,
        Message
    }
}

export function AdminRegister(organizationName, organizationNumber, organizationPhoneNumber, organizationAddress, pinCode, city, state, country,isPrimary,userType, dispatch) {
    
    let data = {
        organizationName: organizationName,
        organizationNumber: organizationNumber,
        organizationPhoneNumber: organizationPhoneNumber,
        organizationAddress: organizationAddress,
        pinCode: pinCode,
        city: city,
        state: state,
        country: country,
        UserType:userType,
        IsPrimary:isPrimary
    }

    // return (dispatch) => {
    //     ;
    //     dispatch(fetchOrganizationRequest({ organizationName: organizationName, organizationNumber: organizationNumber, organizationPhoneNumber: organizationPhoneNumber, organizationAddress: organizationAddress, pinCode: pinCode, city: city, state: state, country: country, isLoading: true }));
    //     return varAxios.post(saveOrganizationUrl, data,
    //         JSON.stringify({
    //             derived: 'd',
    //             message: 'e'
    //         }))
    //         .then((response) => {
    //             console.log(response);
    //             dispatch(
    //                 fetchOrganizationSuccess({
    //                     organizationName: organizationName, organizationNumber: organizationNumber, organizationPhoneNumber: organizationPhoneNumber, organizationAddress: organizationAddress, pinCode: pinCode, city: city, state: state, country: country, isLoading: false,
    //                     Message: response.data.Message
    //                 }));
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    // }
}


